module.exports = __webpack_public_path__ + "static/media/logo_lpr.f76a0d1f.png";